export const processType = [
    { id: 1, name: 'CNC Machining' },
    { id: 2, name: '3D Printing' },
    { id: 3, name: 'Sheet Metal Fabrication' },
    { id: 4, name: 'Injection Molding/Casting' },
    { id: 5, name: 'Complete Assembly' },
    { id: 6, name: 'Vacuum Casting' },
    { id: 7, name: 'Jigs and Fixtures' },
    { id: 8, name: 'Off-the-shelf parts (OEM)' },
    { id: 9, name: '3D Printing' },
    { id: 10, name: 'CNC Machining' },
    { id: 11, name: 'Others' },
    { id: 12, name: 'Reverse Engineering' }
]


export const MAX_FILE_LIMIT = 104857600 //100mb

export const handleLogout = (navigate, redirectUrl) => {
    localStorage.removeItem("Token");
    localStorage.removeItem("_id");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("email");
    localStorage.removeItem("pathAfterLogin");
    navigate && navigate("/", { state: { from: redirectUrl || "/" } });
}